import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { Utils } from '@americanexpress/axp-benefits-utils';
import { fromJS } from 'immutable';
import Body from './Body';
import ViewAllTile from './view-all-tile/view-all-tile.jsx';
import LayoutContainer from './LayoutContainer';
import DetailPageTile from './DetailPageTile.tsx';
import normalize from './utils/normalize.ts';
import {
  CardBenefitsTilePropTypes,
  concatDisclosures,
  getDisclosureHeading,
} from './utils';

export function CardBenefitsTile(props) {
  const view = props?.view;
  const benefit = props?.benefit;
  const benefitsData = props?.benefitsData;
  const runBenefits = props?.runBenefits;
  const refreshBenefitsData = props?.refreshBenefitsData;
  const localeDetails = props?.locale;

  if (!view || !benefit) {
    if (process.env.NODE_ENV === 'development') {
      return <div data-testid="error">CardBenefitsTile failed to load some of its asynchronous data</div>;
    }
    return null;
  }

  const showMobileTileView = props?.showMobileTileView;
  const cardname = props?.cardname;
  const isListView = props?.isListView;
  const productSelected = props?.productSelected;
  const IMAGE_DOMAIN = props?.IMAGE_DOMAIN;
  const env = props?.env;
  const login = props?.login;
  const showTerms = props?.showTerms;
  const benefitNamesList = props?.benefitNamesList;
  const catalogFilters = props?.catalogFilters;
  const searching = props?.searching;

  // Show view-all tile when "view-all" is passed in view prop, isListView can be set to show tiles as a list
  if (view === 'view-all') {
    const normalizedBenefit = normalize(benefit);

    return (
      <ViewAllTile
        searching={searching}
        benefit={normalizedBenefit}
        cardname={cardname}
        showMobileTileView={showMobileTileView}
        isListView={isListView}
        productSelected={productSelected}
        benefitNamesList={benefitNamesList}
        benefitsData={benefitsData}
        catalogFilters={catalogFilters}
      />
    );
  }

  // Show detail page tile when detail is passed in view prop
  if (view === 'detail') {
    const normalizedBenefit = normalize(benefit);
    let includesDisclosures = !!normalizedBenefit?.disclosures;
    if (includesDisclosures) {
      // Checks for empty array, arr[]
      if (normalizedBenefit?.disclosures.length === 0) {
        includesDisclosures = false;
      }
      // Checks for a null in the array, arr[null]
      if (normalizedBenefit?.disclosures[0] === null) {
        includesDisclosures = false;
      }
    }

    let disclosureHeading = '';
    let formattedDisclosures = [];

    if (includesDisclosures) {
      disclosureHeading = getDisclosureHeading(normalizedBenefit?.disclosures[0].type);
      formattedDisclosures = concatDisclosures(normalizedBenefit?.disclosures);
    }

    // Construct resyModuleProps for detail view
    const resyModuleProps = {
      benefitTitle: normalizedBenefit?.title,
      details: normalizedBenefit?.detail,
      disclosures: normalizedBenefit?.disclosures,
    };

    return (
      <LayoutContainer type="detail">
        <DetailPageTile
          benefit={normalizedBenefit}
          benefitsData={benefitsData}
          cardname={cardname}
          imageUrl={IMAGE_DOMAIN}
          env={env}
          login={login}
          showDisclosures={includesDisclosures}
          disclosureHeading={disclosureHeading}
          disclosureDescription={formattedDisclosures}
          showTerms={showTerms}
          localeDetails={localeDetails}
          resyModuleProps={resyModuleProps}
          runBenefits={runBenefits}
          refreshBenefitsData={refreshBenefitsData}
        />
        <Body />
      </LayoutContainer>
    );
  }
}

CardBenefitsTile.propTypes = CardBenefitsTilePropTypes;

CardBenefitsTile.defaultProps = {
  benefitName: '',
  cardname: '',
  isListView: false,
  IMAGE_DOMAIN: '',
  env: '',
  view: 'view-all', // value can be view-all or detail
};

export function mapStateToProps(state) {
  const cmsDomain = fromJS(state).getIn(['config', 'gemUrl']);
  return {
    IMAGE_DOMAIN: `${cmsDomain}/content/dam/one-amex/benefits/`,
    env: fromJS(state).getIn(['config', 'localeFilename']),
  };
}

const hocChain = compose(
  connect(mapStateToProps),
  oneAppModuleWrapper('axp-benefits-view-all')
);

export const ComponentUnderTest = CardBenefitsTile;
export default hocChain(Utils.MobileRender(CardBenefitsTile, 430));
